/* Seravele — premium restyle helpers.
   Loaded next to seravele-premium.css in layout/theme.liquid; remove both lines to undo.

   1. Trademark sign in headings: wraps every "™" inside a heading in
      <sup class="sv-tm"> so it can be styled as a small superscript. */
(function () {
  var HEADINGS = 'h1, h2, h3, h4, h5, h6, .h0, .h1, .h2, .h3, .h4, .h5, .card__heading';
  var TM = '™';

  function wrapTrademarks(root) {
    var headings = root.querySelectorAll ? root.querySelectorAll(HEADINGS) : [];
    Array.prototype.forEach.call(headings, function (heading) {
      var walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
      var nodes = [];
      while (walker.nextNode()) {
        var node = walker.currentNode;
        var parent = node.parentNode;
        if (node.nodeValue.indexOf(TM) === -1) continue;
        if (parent && parent.classList && parent.classList.contains('sv-tm')) continue;
        nodes.push(node);
      }
      nodes.forEach(function (node) {
        var parts = node.nodeValue.split(TM);
        var frag = document.createDocumentFragment();
        parts.forEach(function (part, i) {
          if (i > 0) {
            var sup = document.createElement('sup');
            sup.className = 'sv-tm';
            sup.textContent = TM;
            frag.appendChild(sup);
          }
          // no gap before the sign
          if (i < parts.length - 1) part = part.replace(/\s+$/, '');
          if (part) frag.appendChild(document.createTextNode(part));
        });
        node.parentNode.replaceChild(frag, node);
      });
    });
  }

  function run() { wrapTrademarks(document); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // Theme editor: re-run when a section is re-rendered
  document.addEventListener('shopify:section:load', function (e) { wrapTrademarks(e.target); });
})();

/* 2. Product gallery dots (mobile): one dot per visible main image under the
      swipe row; the active dot follows the scroll, tapping a dot scrolls to it.
      Styling + "mobile only" live in seravele-premium.css (.sv-gallery-dots). */
(function () {
  function setup(viewer) {
    if (viewer.hasAttribute('data-sv-dots')) return;
    var list = viewer.querySelector('.product__media-list');
    if (!list) return;
    viewer.setAttribute('data-sv-dots', '');
    var dots = document.createElement('div');
    dots.className = 'sv-gallery-dots';
    viewer.insertAdjacentElement('afterend', dots);

    function slides() {
      return Array.prototype.filter.call(list.children, function (li) {
        return li.classList.contains('product__media-item') && li.offsetParent !== null;
      });
    }
    function startEdge() {
      // the slider has a mobile gutter (padding); slides snap to the padded edge
      return list.getBoundingClientRect().left + (parseFloat(getComputedStyle(list).paddingLeft) || 0);
    }
    function current(items) {
      var best = 0, bestDist = Infinity, left = startEdge();
      items.forEach(function (li, i) {
        var d = Math.abs(li.getBoundingClientRect().left - left);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }
    function render() {
      var items = slides();
      dots.innerHTML = '';
      dots.hidden = items.length < 2;
      items.forEach(function (li, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sv-gallery-dots__dot';
        b.setAttribute('aria-label', (i + 1) + ' / ' + items.length);
        b.addEventListener('click', function () {
          list.scrollBy({ left: li.getBoundingClientRect().left - startEdge(), behavior: 'smooth' });
        });
        dots.appendChild(b);
      });
      update();
    }
    function update() {
      var items = slides(), idx = current(items);
      Array.prototype.forEach.call(dots.children, function (b, i) {
        b.setAttribute('aria-current', i === idx ? 'true' : 'false');
      });
    }
    list.addEventListener('scroll', update, { passive: true });
    list.addEventListener('scrollend', update, { passive: true });
    viewer.addEventListener('slideChanged', update); // Dawn's slider-component event
    window.addEventListener('resize', render);
    // variant changes can show/hide media items: rebuild only when the count changes
    new MutationObserver(function () {
      if (slides().length !== dots.children.length) render(); else update();
    }).observe(list, { attributes: true, subtree: true, attributeFilter: ['class', 'hidden'] });
    render();
  }
  function run() {
    document.querySelectorAll('media-gallery [id^="GalleryViewer"]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();

/* 3. Testimonial cards under add to cart (main-product "Testemunho" blocks):
      fade to the next card every 6 s, swipe on touch screens, pause while
      hovered/touched or focused, dash indicators; no auto-rotation with
      "reduce motion". */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function setup(root) {
    if (root.hasAttribute('data-sv-ready')) return;
    root.setAttribute('data-sv-ready', '');
    var cards = root.querySelectorAll('.sv-reviews__card');
    var dashes = root.querySelectorAll('.sv-reviews__dash');
    if (cards.length < 2) return;
    var index = 0, timer = null, paused = false;
    function show(i) {
      index = (i + cards.length) % cards.length;
      Array.prototype.forEach.call(cards, function (c, n) {
        var on = n === index;
        c.classList.toggle('is-active', on);
        if (on) c.removeAttribute('aria-hidden'); else c.setAttribute('aria-hidden', 'true');
      });
      Array.prototype.forEach.call(dashes, function (d, n) {
        if (n === index) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    function start() {
      if (reduce || timer) return;
      timer = setInterval(function () { if (!paused) show(index + 1); }, 6000);
    }
    function pause() { paused = true; }
    function resume() { paused = false; }
    Array.prototype.forEach.call(dashes, function (d, n) {
      d.addEventListener('click', function () { show(n); });
    });
    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', resume);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', resume);
    var x0 = null;
    root.addEventListener('touchstart', function (e) { pause(); x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 !== null) {
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
      }
      x0 = null;
      setTimeout(resume, 3000);
    }, { passive: true });
    start();
  }
  function run() { document.querySelectorAll('[data-sv-reviews]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();

/* 4. Product rating line ("4,7 / 5 · …"): mark it .is-wrapped when the text
      after the dot drops to a second line, so the CSS can hide the dot. */
(function () {
  function check() {
    document.querySelectorAll('.vz-rr').forEach(function (row) {
      var a = row.querySelector('.vz-rr__txt'), b = row.querySelector('.vz-rr__sub');
      if (!a || !b) return;
      row.classList.remove('is-wrapped');
      if (Math.abs(b.getBoundingClientRect().top - a.getBoundingClientRect().top) > 4) row.classList.add('is-wrapped');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check);
  else check();
  window.addEventListener('resize', check);
  window.addEventListener('load', check);
})();
